<template>
  <div class="ArticlesContent_left">
    <div v-if="articlesData">
      <div
        class="tit"
        :class="[language == 'zh' ? 'zhFamilytitle' : 'enfamilytitle']"
      >
        {{ articlesData.title }}
      </div>
      <div class="date" :class="[language == 'zh' ? 'zhFamily' : 'enfamily']">
        {{ articlesData.releaseTime }}
      </div>
      <div v-html="articlesData.content"></div>
    </div>
    <!-- <img src="../../../assets/image/Articles/Articles_img.jpg" alt="" /> -->
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
    mixins: [mapMixin],
  props: ["articlesData"],
  mounted() {},
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .ArticlesContent_left {
    width: 900px;
    // margin: auto;
    .date {
      color: #999;
      font-size: 14px;
      margin-bottom: 20px;
    }
    .tit {
      padding: 20px;
      margin-bottom: 10px;
      color: #000;
      font-weight: 600;
      font-size: 16px;
      background: rgba(245, 245, 245, 1);
      border-bottom: 2px solid rgba(235, 235, 235, 1);
    }
    div {
      line-height: 30px;
    }
    img {
      width: 100%;
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .ArticlesContent_left {
    width: 900px;
    // margin: auto;
    .date {
      color: #ccc;
      font-size: 14px;
      margin-bottom: 20px;
    }
    .tit {
      padding: 20px;
      margin-bottom: 20px;
      color: #000;
      font-weight: 600;
      font-size: 16px;
      background: rgba(245, 245, 245, 1);
      border-bottom: 2px solid rgba(235, 235, 235, 1);
    }
    div {
      line-height: 30px;
    }
    img {
      width: 100%;
    }
  }
}
@media screen and (max-width: 767px) {
  .ArticlesContent_left {
    width: 100%;
    padding: 10px;
    // margin: auto;
    .date {
      color: rgba(51, 51, 51, 1);
      font-size: 16px;
      margin-bottom: 8px;
    }
    .tit {
      padding: 10px;
      margin-bottom: 10px;
      color: #000;
      font-weight: 600;
      font-size: 16px;
      // background: rgba(245, 245, 245, 1);
      border-bottom: 2px solid rgba(235, 235, 235, 1);
    }
    div {
      line-height: 30px;
    }
    img {
      width: 100%;
      object-fit: cover;
    }
  }
}
</style>